// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* UserMenu — floating account control, top-right of every page. */

.user-menu {
  position: relative;
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
}

.user-menu-trigger {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  border: none;
  cursor: pointer;
  /* White disc with a purple initial: contrasts on the purple header and
     mirrors the sidebar's selected-pill (white bg, #5616ea text). */
  background: #ffffff;
  color: #5616ea;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.25);
  transition: transform 0.15s ease, box-shadow 0.15s ease;
  padding: 0;
  font-family: inherit;
}

.user-menu-trigger:hover,
.user-menu-trigger.open {
  transform: translateY(-1px);
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.3);
}

.user-menu-avatar {
  display: block;
  width: 100%;
  height: 100%;
}
.user-menu-avatar text {
  fill: #5616ea;
  font-family: "DM Sans", sans-serif;
  font-size: 15px;
  font-weight: 700;
}

.user-menu-dropdown {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  min-width: 210px;
  background: #fff;
  color: #222;
  border-radius: 10px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.18), 0 1px 4px rgba(0, 0, 0, 0.12);
  padding: 6px 0;
  overflow: hidden;
}

.user-menu-greeting {
  padding: 8px 14px 6px 14px;
  font-size: 12px;
  font-weight: 600;
  color: #888;
  text-transform: capitalize;
}

.user-menu-item {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 10px 14px;
  background: transparent;
  border: none;
  cursor: pointer;
  text-align: left;
  color: #222;
  font-size: 14px;
  font-family: inherit;
  transition: background 0.12s ease;
}

.user-menu-item:hover {
  background: #f4f1fe;
}

.user-menu-item.logout {
  color: #b00020;
}

.user-menu-item.logout:hover {
  background: #fdecec;
}

.user-menu-item-icon {
  width: 18px;
  display: inline-flex;
  justify-content: center;
  color: #5616ea;
  font-size: 14px;
  flex-shrink: 0;
}

.user-menu-item.logout .user-menu-item-icon {
  color: #b00020;
}

.user-menu-divider {
  height: 1px;
  background: #eee;
  margin: 6px 0;
}
`, "",{"version":3,"sources":["webpack://./src/components/UserMenu.css"],"names":[],"mappings":"AAAA,kEAAkE;;AAElE;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf;oEACkE;EAClE,mBAAmB;EACnB,cAAc;EACd,yCAAyC;EACzC,uDAAuD;EACvD,UAAU;EACV,oBAAoB;AACtB;;AAEA;;EAEE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;AACA;EACE,aAAa;EACb,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,yEAAyE;EACzE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,oBAAoB;EACpB,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;AACf","sourcesContent":["/* UserMenu — floating account control, top-right of every page. */\r\n\r\n.user-menu {\r\n  position: relative;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.user-menu-trigger {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 30px;\r\n  height: 30px;\r\n  border-radius: 50%;\r\n  border: none;\r\n  cursor: pointer;\r\n  /* White disc with a purple initial: contrasts on the purple header and\r\n     mirrors the sidebar's selected-pill (white bg, #5616ea text). */\r\n  background: #ffffff;\r\n  color: #5616ea;\r\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.25);\r\n  transition: transform 0.15s ease, box-shadow 0.15s ease;\r\n  padding: 0;\r\n  font-family: inherit;\r\n}\r\n\r\n.user-menu-trigger:hover,\r\n.user-menu-trigger.open {\r\n  transform: translateY(-1px);\r\n  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.3);\r\n}\r\n\r\n.user-menu-avatar {\r\n  display: block;\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n.user-menu-avatar text {\r\n  fill: #5616ea;\r\n  font-family: \"DM Sans\", sans-serif;\r\n  font-size: 15px;\r\n  font-weight: 700;\r\n}\r\n\r\n.user-menu-dropdown {\r\n  position: absolute;\r\n  top: calc(100% + 8px);\r\n  right: 0;\r\n  min-width: 210px;\r\n  background: #fff;\r\n  color: #222;\r\n  border-radius: 10px;\r\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.18), 0 1px 4px rgba(0, 0, 0, 0.12);\r\n  padding: 6px 0;\r\n  overflow: hidden;\r\n}\r\n\r\n.user-menu-greeting {\r\n  padding: 8px 14px 6px 14px;\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  color: #888;\r\n  text-transform: capitalize;\r\n}\r\n\r\n.user-menu-item {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  width: 100%;\r\n  padding: 10px 14px;\r\n  background: transparent;\r\n  border: none;\r\n  cursor: pointer;\r\n  text-align: left;\r\n  color: #222;\r\n  font-size: 14px;\r\n  font-family: inherit;\r\n  transition: background 0.12s ease;\r\n}\r\n\r\n.user-menu-item:hover {\r\n  background: #f4f1fe;\r\n}\r\n\r\n.user-menu-item.logout {\r\n  color: #b00020;\r\n}\r\n\r\n.user-menu-item.logout:hover {\r\n  background: #fdecec;\r\n}\r\n\r\n.user-menu-item-icon {\r\n  width: 18px;\r\n  display: inline-flex;\r\n  justify-content: center;\r\n  color: #5616ea;\r\n  font-size: 14px;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.user-menu-item.logout .user-menu-item-icon {\r\n  color: #b00020;\r\n}\r\n\r\n.user-menu-divider {\r\n  height: 1px;\r\n  background: #eee;\r\n  margin: 6px 0;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
